import React from 'react'
import { Link } from 'react-router-dom'
import "./Header.css";
import SearchIcon from '@material-ui/icons/Search';
import { useStateValue } from './StateProvider';
import { auth } from './firebase';

function Header() {
    const [{ basket, user}, dispatch] = useStateValue();

    const handleAuthentication = () => {
        if (user) {
            auth.signOut();
        }
    }
    return (
        <div className="header">
            <Link to="/">
            <h1 className="header__title">dine-bahar</h1>
            </Link>
            
            <div className="header__search">
                <input className="header__searchInput" type="text" size="65" id="inputbox1" placeholder="Search Restaurant Here"/>
                <SearchIcon className="header__searchIcon" />
            </div>

            <Link to={!user && '/login'} >
            <div className="header__login" onClick={handleAuthentication}>
                {/* <span>{user ? '' : 'Sign In'}</span> */}
                {user ? <img src="images/logout.png" className="abc_123"/> : 
                <img src="images/enter.png" className="abc_123"/>}
            </div>
            </Link>

            <Link to='/showmytable'>
            <img className="header__table" src="/images/dining-table.png" alt="this is an image" />
            <span className='total_items'>{basket?.length}</span>
            </Link>
        </div>
    )
}

export default Header
